export enum AssignmentKey {
  ASSIGNMENT = 'assignment',
  ASSIGNED_ASSIGNMENTS = 'assignedAssignments',
  ASSIGNED_ASSIGNMENTS_INFINITE = 'assignedAssignmentsInfinite',
  ASSIGNMENT_SUBMISSIONS = 'assignmentSubmissions',
}
